module.exports = "/_next/static/images/image-oliver-and-anna-homepage-d6b54b788f0c479e36f7d6574585a484.svg";